import {RoomClientState} from '../../RoomClientState.ts'
import {ViewPopup} from '../../ui_popup/ViewPopup'
import {UIRoomWarningPopupContentBase} from './UIRoomWarningPopupContentBase'
import {ReadyUpExceedLimitWarningContent} from './UIRoomWarningPopupReadyUpExceedLimit'
import {StartGameExceedLimitWarningContent} from './UIRoomWarningPopupStartGameExceedVPLimit'

export enum WarningType {
    StartGameVPExceededRecommendedLimit,
    ReadyUpVPExceededRecommendedLimit,
}

export class UIRoomWarningController {
    static runWithWarning(continuationAction: (userAgreed?: boolean) => void, warningType: WarningType, roomState: RoomClientState) {
        const warningPopup = this.getWarningPopupContent(warningType, roomState)
        if(!warningPopup.shouldShowWarning()) {
            continuationAction()
            return
        }

        const popup = new ViewPopup(warningPopup.getTitle(), warningPopup.getDescription(), () => continuationAction(true), () => undefined, true)
        popup.show()
    }

    static getWarningPopupContent(warningType: WarningType, roomState: RoomClientState): UIRoomWarningPopupContentBase {
        switch(warningType) {
            case WarningType.StartGameVPExceededRecommendedLimit: return new StartGameExceedLimitWarningContent(roomState)
            case WarningType.ReadyUpVPExceededRecommendedLimit: return new ReadyUpExceedLimitWarningContent(roomState)
        }
    }
}

